// Flow types automatically removed

import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import getter from 'dibs-object-getter';
import classnames from 'classnames';
import { Button } from 'dibs-elements/exports/Button';
import { InteriorsLandingViewAllButton } from './InteriorsLandingViewAllButton';
import styles from './styles/InteriorsLandingRooms.scss';

const renderRooms = (rooms, displayType) => {
    if (displayType === 'primary') {
        return null;
    }

    const colClasses = displayType === 'tertiary' ? 'colXs6 colLg3' : 'colXs12  colLg6';
    return (
        <div className="rowFlex" data-tn={`interiors-landing-${displayType}-rooms-row`}>
            {rooms.map(({ linkUrl, imageUrl, title }, index) => (
                <div
                    className={classnames(styles.room, colClasses)}
                    key={`rooms-${displayType}-${index}`}
                    data-tn={`interiors-landing-${displayType}-rooms-tile`}
                >
                    <Link href={linkUrl} className={styles.roomImageWrapper} dataTn="image-link">
                        <img
                            data-tn="image"
                            src={imageUrl}
                            alt={title}
                            className={styles.roomImage}
                        />
                    </Link>
                    <Link href={linkUrl} className={styles.secondaryRoomTitle} dataTn="link">
                        {title}
                    </Link>
                </div>
            ))}
        </div>
    );
};

export function InteriorsLandingRoomsComponent({ roomsModule }) {
    const secondaryRoomsModule = getter(roomsModule).value('secondaryRoomsModule');
    const secondaryRoomItems = (getter(secondaryRoomsModule).value('items') || []).filter(Boolean);
    const secondaryIsVisible =
        getter(secondaryRoomsModule).value('isVisible') && secondaryRoomItems.length > 0;
    const tertiaryRoomsModule = getter(roomsModule).value('tertiaryRoomsModule');
    const tertiaryRoomItems = (getter(tertiaryRoomsModule).value('items') || []).filter(Boolean);
    const tertiaryIsVisible =
        getter(tertiaryRoomsModule).value('isVisible') && tertiaryRoomItems.length > 0;
    return (
        <Fragment>
            {secondaryIsVisible && renderRooms(secondaryRoomItems, 'secondary')}
            {tertiaryIsVisible && renderRooms(tertiaryRoomItems, 'tertiary')}
            {(secondaryIsVisible || tertiaryIsVisible) && (
                <div
                    className={styles.viewAllWrapper}
                    data-tn="interiors-landing-view-all-rooms-row"
                >
                    <InteriorsLandingViewAllButton>
                        <Button
                            dataTn="interiors-landing-view-all-rooms"
                            href="/photos/"
                            type="secondary"
                        >
                            <FormattedMessage
                                id="abt.interiorsLanding.viewAllPhotos"
                                defaultMessage="Browse All Photos"
                            />
                        </Button>
                    </InteriorsLandingViewAllButton>
                </div>
            )}
        </Fragment>
    );
}
export const InteriorsLandingRooms = createFragmentContainer(InteriorsLandingRoomsComponent, {
    roomsModule: graphql`
        fragment InteriorsLandingRooms_roomsModule on InteriorsLandingPage {
            secondaryRoomsModule {
                isVisible
                displayType
                items {
                    linkUrl
                    imageHeight
                    imageUrl
                    imageWidth
                    title
                }
            }
            tertiaryRoomsModule {
                isVisible
                displayType
                items {
                    linkUrl
                    imageHeight
                    imageUrl
                    imageWidth
                    title
                }
            }
        }
    `,
});
